import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { IRootState } from 'reducers';
import type { AppDispatch } from 'store';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
